
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.083 7.5h-1.25V5.833A5.84 5.84 0 0010 0a5.84 5.84 0 00-5.833 5.833V7.5h-1.25a.416.416 0 00-.417.417v10.416c0 .92.747 1.667 1.667 1.667h11.666c.92 0 1.667-.747 1.667-1.667V7.917a.416.416 0 00-.417-.417zm-5.835 8.704a.417.417 0 01-.415.463H9.167a.417.417 0 01-.415-.463l.263-2.364a1.649 1.649 0 01-.682-1.34c0-.92.748-1.667 1.667-1.667.92 0 1.667.748 1.667 1.667 0 .539-.255 1.03-.682 1.34l.263 2.364zM13.333 7.5H6.667V5.833A3.337 3.337 0 0110 2.5a3.337 3.337 0 013.333 3.333V7.5z"}})])
          )
        }
      }
    